import React, { useMemo } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { translate } from '@utils/i18n';
import { MainContentBanner } from '@components/MainContentBanner';
import useGetLastIaRun from './hooks/useGetLastIaRun';
const namespace = 'features.ia_results_banner';
function IaResultsBannerContent() {
    var _a;
    const { data: lastRunData, isLoading, isError } = useGetLastIaRun();
    const handleClick = () => {
        window.location.href = '/inspection_assistant_review';
    };
    if (isLoading || isError) {
        return null;
    }
    if (!(lastRunData === null || lastRunData === void 0 ? void 0 : lastRunData.iimRun) ||
        !(lastRunData === null || lastRunData === void 0 ? void 0 : lastRunData.inspectionAssistantTeaserEnabled) ||
        (lastRunData === null || lastRunData === void 0 ? void 0 : lastRunData.isInspectpointUser) ||
        (!(lastRunData === null || lastRunData === void 0 ? void 0 : lastRunData.isInspectpointUser) && !((_a = lastRunData === null || lastRunData === void 0 ? void 0 : lastRunData.iimRun) === null || _a === void 0 ? void 0 : _a.published))) {
        return null;
    }
    return (React.createElement(MainContentBanner, { title: translate('title', { namespace }), buttonTitle: translate('button_title', { namespace }), dismissTitle: translate('dismiss_banner', { namespace }), dismissKey: "ia-results-banner-dismissed", onClick: handleClick, icon: React.createElement("i", { className: "fa-sharp fa-light fa-star-shooting" }) }));
}
function IaResultsBanner() {
    const queryClient = useMemo(() => new QueryClient(), []);
    return (React.createElement(QueryClientProvider, { client: queryClient },
        React.createElement(IaResultsBannerContent, null)));
}
export default IaResultsBanner;
